import { ListItem, Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  HelpDialogList,
  SectionStack,
} from "./HelpDialogLayout";

export interface BeforeSleepMindDialogProps extends HelpDialogLayoutProps {}
export default function BeforeSleepMindDialog(
  props: BeforeSleepMindDialogProps
) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "眠りにつく時は、自律神経の中で体をリラックスさせる作用のある副交感神経が優位になります。しかし、ストレスや不安を感じていたり、興奮・緊張状態だと交感神経が優位となり、スムーズな入眠を妨げてしまいます。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">
            リラックスして寝床に入りましょう
          </Typography>
          <HelpDialogList>
            <ListItem>
              <Typography variant="body2">
                寝床に入る少なくとも1時間前は家事や仕事に追われずリラックスする時間を確保しましょう。日中との切り離しができる「自分なりの睡眠習慣」が構築できることが望ましいです。
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2">
                医療現場では「筋弛緩法（きんしかんほう）」と呼ばれる、一度10秒程度筋肉に力をいれてその後15秒かけて脱力する、という運動法が紹介されることが多いですが、それに限らず入浴や、瞑想、静かに行うヨガ、腹式呼吸、音楽やアロマなど、自分が心地よさを感じる方法を見つけましょう。読書などをする時は、できるだけスマホや電子媒体を利用せず、アナログな方法を心がけましょう。
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2">
                心配事などは「明日考えることリスト」やもしくはノートに思いつくままに感情をに書き留めて、寝床には持ち込まないようにしましょう。「書く」行為はシンプルながら、感情の浄化作用が強く、また感情を客観視したり新しい視点でとらえる機会ともなり、不安が改善し、ストレスが大幅に軽減することが心理学や社会学にて報告されています。
              </Typography>
            </ListItem>
          </HelpDialogList>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
